"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var COLOR_PALETTE = {
  global: {
    base: {
      white: '#ffffff',
      black: '#000000',
      orange1: '#f37321',
      orange2: '#ff8b00',
      orange3: '#faf1e6',
      orange4: '#fdf1e8',
      orange5: '#d5651e',
      orange6: '#b5561a',
      orange7: '#fac7a6',
      orange8: '#fef8f4',
      orange9: '#fdeade',
      orange10: '#fef2e8',
      orange11: '#FFB687',
      orange12: '#fde8da',
      orange13: '#ffdaaf',
      orange14: '#ffae50',
      orange15: '#d5651c',
      orange16: '#6a320e',
      orange17: '#b55618',
      orange18: '#fef0e8',
      orange19: '#ffae5041',
      orange20: '#f37420bf',
      cyan: '#01b5de',
      green: '#13c333',
      red: '#ff5959',
      blue1: '#007aff',
      blue2: '#212b36',
      blue3: '#335977',
      blue4: '#637b8b',
      gray1: '#4a4a4a',
      gray2: '#a3a3a3',
      gray3: '#c7c8ca',
      gray4: '#e5e5e5',
      gray5: '#f6f6f6',
      gray6: '#929292',
      gray7: '#b6b6b6',
      gray8: '#4D4F5C',
      gray9: '#f7f7f7',
      gray10: '#eeeeef',
      gray11: '#f4f4f4',
      gray12: '#b7b7b7',
      gray13: '#637381',
      gray14: '#B2C7D5',
      gray15: '#868686',
      gray16: '#e1e1e1',
      gray17: '#9E9E9E',
      gray18: '#f1f1f1',
      gray19: '#f5f7f8',
      gray20: '#c7c7ca'
    },
    grayScale: {
      orange1: {
        o50: 'rgba(243, 115, 33, 0.5)'
      },
      orange14: {
        o25: 'rgb(255, 174, 80, 0.25)' // #ffae5040

      },
      black: {
        b05: 'rgba(0, 0, 0, 0.05)',
        // #0000000d
        b08: 'rgba(0, 0, 0, 0.08)',
        // #00000014
        b10: 'rgba(0, 0, 0, 0.1)',
        // #0000001a
        b12: 'rgba(0, 0, 0, 0.12)',
        // #0000001f
        b15: 'rgba(0, 0, 0, 0.15)',
        // #00000026
        b20: 'rgba(0, 0, 0, 0.2)',
        // #00000033
        b35: 'rgba(0, 0, 0, 0.35)',
        // #00000059
        b38: 'rgba(0, 0, 0, 0.38)',
        // #00000061
        b45: 'rgba(0, 0, 0, 0.45)',
        // #00000073
        b50: 'rgba(0, 0, 0, 0.5)',
        // #00000080
        b54: 'rgba(0, 0, 0, 0.54)',
        // #0000008a
        b75: 'rgba(0, 0, 0, 0.75)',
        // #000000bf
        b85: 'rgba(0, 0, 0, 0.85)' // #000000d9

      },
      blue2: {
        b8: '#212b3614' // rgba(33, 43, 54, 0.8);

      },
      gray1: {
        g8: 'rgb(74, 74, 74, 0.08)',
        // #4a4a4a14
        g1: 'rgb(74, 74, 74, 0.1)',
        // #4a4a4a1a
        g3: 'rgb(74, 74, 74, 0.3)',
        // #4a4a4a4d
        g60: 'rgb(74, 74, 74, 0.6)',
        // #4a4a4a99
        g80: 'rgba(74, 74, 74, 0.8)' // #4a4a4acc

      },
      gray2: {
        g30: '#A3A3A34D',
        g50: 'rgba(163, 163, 163, 0.5)'
      },
      gray3: {
        g40: 'rgba(199, 200, 202, 0.4)'
      }
    }
  },
  lightTheme: {},
  darkTheme: {}
};
var _default = {
  'enphase-AddDeduct': {
    text: COLOR_PALETTE.global.base.gray1,
    background: COLOR_PALETTE.global.base.orange4,
    'background-hover': COLOR_PALETTE.global.base.orange1,
    fill: COLOR_PALETTE.global.base.orange1,
    'fill-hover': COLOR_PALETTE.global.base.orange4
  },
  'enphase-AddressBook': {
    'icon-button-hover': COLOR_PALETTE.global.grayScale.gray1.g8,
    'mapArea-background': COLOR_PALETTE.global.base.black
  },
  'enphase-Backdrop': {
    'background-color': COLOR_PALETTE.global.grayScale.black.b50
  },
  'enphase-Badge': {
    'text-color': COLOR_PALETTE.global.base.white,
    'box-shadow': COLOR_PALETTE.global.base.white,
    default: COLOR_PALETTE.global.base.blue1,
    success: COLOR_PALETTE.global.base.blue1,
    processing: COLOR_PALETTE.global.base.blue1,
    error: COLOR_PALETTE.global.base.blue1,
    warning: COLOR_PALETTE.global.base.blue1
  },
  'enphase-Button': {
    // Primary
    primary: COLOR_PALETTE.global.base.orange1,
    // #f37222
    'primary-text-color': COLOR_PALETTE.global.base.white,
    // #ffffff
    'primary-border': COLOR_PALETTE.global.base.orange17,
    // #b55618
    'primary-hover': COLOR_PALETTE.global.base.orange15,
    // #d5651c
    'primary-hover-text-color': COLOR_PALETTE.global.base.white,
    // #ffffff
    'primary-hover-border': COLOR_PALETTE.global.base.orange17,
    // #b55618
    'primary-active': COLOR_PALETTE.global.base.orange17,
    // #b55618
    'primary-active-text-color': COLOR_PALETTE.global.base.white,
    // #ffffff
    'primary-active-border': COLOR_PALETTE.global.base.orange17,
    // #b55618
    'primary-focus': COLOR_PALETTE.global.base.orange15,
    // #d5651c
    'primary-focus-text-color': COLOR_PALETTE.global.base.white,
    // #ffffff
    'primary-focus-border': COLOR_PALETTE.global.base.orange17,
    // #b55618
    'primary-disabled': COLOR_PALETTE.global.base.orange7,
    // #fac7a6
    'primary-disabled-text-color': COLOR_PALETTE.global.base.white,
    // #ffffff
    'primary-disabled-border': 'none',
    // Secondary
    secondary: COLOR_PALETTE.global.base.white,
    // #ffffff
    'secondary-text-color': COLOR_PALETTE.global.base.gray1,
    // #4a4a4a
    'secondary-border': COLOR_PALETTE.global.base.gray3,
    // #c7c8ca
    'secondary-hover': COLOR_PALETTE.global.base.gray9,
    // #f7f7f7
    'secondary-hover-text-color': COLOR_PALETTE.global.base.gray1,
    // #4a4a4a
    'secondary-hover-border': COLOR_PALETTE.global.base.gray3,
    // #c7c8ca
    'secondary-active': COLOR_PALETTE.global.base.gray10,
    // #eeeeef
    'secondary-active-text-color': COLOR_PALETTE.global.base.gray1,
    // #4a4a4a
    'secondary-active-border': COLOR_PALETTE.global.base.gray3,
    // #c7c8ca
    'secondary-focus': COLOR_PALETTE.global.base.gray11,
    // #f4f4f4
    'secondary-focus-text-color': COLOR_PALETTE.global.base.gray1,
    // #4a4a4a
    'secondary-focus-border': COLOR_PALETTE.global.base.gray20,
    // #c7c7ca
    'secondary-disabled': COLOR_PALETTE.global.base.white,
    // #ffffff
    'secondary-disabled-text-color': COLOR_PALETTE.global.grayScale.gray3.g40,
    // #b7b7b7
    'secondary-disabled-border': COLOR_PALETTE.global.grayScale.gray3.g40,
    // #e9e9ea
    // Outlined
    outlined: COLOR_PALETTE.global.base.white,
    // #ffffff
    'outlined-text-color': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-border': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-hover': COLOR_PALETTE.global.base.orange8,
    // #fef8f4
    'outlined-hover-text-color': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-hover-border': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-active': COLOR_PALETTE.global.base.orange9,
    // #fdeade
    'outlined-active-text-color': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-active-border': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-focus': COLOR_PALETTE.global.base.orange18,
    // #fef0e8
    'outlined-focus-text-color': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-focus-border': COLOR_PALETTE.global.base.orange1,
    // #f37222
    'outlined-disabled': COLOR_PALETTE.global.base.orange7,
    // #ffffff
    'outlined-disabled-text-color': COLOR_PALETTE.global.base.orange7,
    // #f9b990
    'outlined-disabled-border': COLOR_PALETTE.global.base.orange7,
    // #fac7a6
    // Text
    'text-color': COLOR_PALETTE.global.base.orange1,
    'text-color-hover': COLOR_PALETTE.global.base.orange1,
    'text-color-disabled': COLOR_PALETTE.global.grayScale.orange1.o50
  },
  'enphase-Card': {
    'background-color': COLOR_PALETTE.global.base.white,
    'box-shadow': COLOR_PALETTE.global.grayScale.black.b10,
    color: 'none'
  },
  'enphase-Checkbox': {
    outline: COLOR_PALETTE.global.base.gray2,
    'outline-disabled': COLOR_PALETTE.global.base.gray2,
    fill: COLOR_PALETTE.global.base.orange1,
    'fill-background-color': COLOR_PALETTE.global.base.white,
    'fill-disabled': COLOR_PALETTE.global.grayScale.gray2.g30,
    'fill-disabled-background-color': COLOR_PALETTE.global.base.gray2,
    'text-color': COLOR_PALETTE.global.base.gray1,
    'text-color-disabled': COLOR_PALETTE.global.grayScale.black.b38,
    'border-color': 'none'
  },
  'enphase-Chip': {
    primary: COLOR_PALETTE.global.base.orange1,
    'text-color': COLOR_PALETTE.global.base.white
  },
  'enphase-Datepicker': {
    'background-color': COLOR_PALETTE.global.base.white,
    'range-select': COLOR_PALETTE.global.base.orange20,
    'box-shadow': COLOR_PALETTE.global.grayScale.blue2.b8,
    'header-text-color': COLOR_PALETTE.global.base.gray1,
    placeholder: COLOR_PALETTE.global.base.gray1,
    'muted-text-color': COLOR_PALETTE.global.base.gray1,
    primary: COLOR_PALETTE.global.base.orange1,
    'unit-text-color': COLOR_PALETTE.global.base.gray13,
    'unit-text-hover': COLOR_PALETTE.global.base.blue2,
    'unit-text-hover-background-color': COLOR_PALETTE.global.base.orange4,
    disabled: COLOR_PALETTE.global.base.gray3,
    selected: COLOR_PALETTE.global.base.white,
    'input-label': COLOR_PALETTE.global.base.gray6,
    'border-color': COLOR_PALETTE.global.base.gray7,
    'input-background-color': 'none',
    'input-text-color': 'none'
  },
  'enphase-Divider': {
    primary: COLOR_PALETTE.global.base.gray14
  },
  'enphase-Drawer': {
    'backdrop-color': COLOR_PALETTE.global.grayScale.black.b45,
    'background-color': COLOR_PALETTE.global.base.white,
    'box-shadow': COLOR_PALETTE.global.grayScale.black.b10,
    'border-color': COLOR_PALETTE.global.base.gray4
  },
  'enphase-Dropdown': {
    'text-color': COLOR_PALETTE.global.grayScale.black.b85
  },
  'enphase-IconButton': {
    color: COLOR_PALETTE.global.grayScale.black.b54,
    border: COLOR_PALETTE.global.base.gray3,
    'hover-background-color': COLOR_PALETTE.global.base.gray5
  },
  'enphase-Info': {
    'text-color': COLOR_PALETTE.global.base.gray1
  },
  'enphase-Input': {
    standard: COLOR_PALETTE.global.base.orange1,
    'standard-background-color': COLOR_PALETTE.global.base.white,
    'standard-text-color': COLOR_PALETTE.global.base.gray1,
    'standard-placeholder': COLOR_PALETTE.global.grayScale.gray1.g60,
    'standard-label-text-color': COLOR_PALETTE.global.base.gray6,
    'standard-label-active-text-color': COLOR_PALETTE.global.base.gray6,
    'standard-error-color': COLOR_PALETTE.global.base.red,
    'standard-disabled-text-color': COLOR_PALETTE.global.base.gray15,
    'standard-border': COLOR_PALETTE.global.base.gray7,
    'standard-helper-text-color': COLOR_PALETTE.global.base.gray6,
    outlined: COLOR_PALETTE.global.base.orange1,
    'outlined-background-color': COLOR_PALETTE.global.base.white,
    'outlined-text-color': COLOR_PALETTE.global.base.gray1,
    'outlined-placeholder': COLOR_PALETTE.global.grayScale.gray1.g60,
    'outlined-label-text-color': COLOR_PALETTE.global.base.gray6,
    'outlined-label-active-text-color': COLOR_PALETTE.global.base.gray6,
    'outlined-error-color': COLOR_PALETTE.global.base.red,
    'outlined-disabled-text-color': COLOR_PALETTE.global.base.gray15,
    'outlined-border': COLOR_PALETTE.global.base.gray7,
    'outlined-helper-text-color': COLOR_PALETTE.global.base.gray6,
    'error-color': COLOR_PALETTE.global.base.red
  },
  'enphase-Link': {
    primary: COLOR_PALETTE.global.base.orange1
  },
  'enphase-Loader': {
    primary: COLOR_PALETTE.global.base.orange1
  },
  'enphase-Menu': {
    'background-color': COLOR_PALETTE.global.base.white,
    'box-shadow-right-color': COLOR_PALETTE.global.grayScale.black.b12,
    'box-shadow-bottom-color': COLOR_PALETTE.global.grayScale.black.b08,
    'box-shadow-left-color': COLOR_PALETTE.global.grayScale.black.b05,
    'text-color': COLOR_PALETTE.global.grayScale.black.b85,
    'hover-background-color': COLOR_PALETTE.global.grayScale.gray1.g8
  },
  'enphase-Modal': {
    'backdrop-color': COLOR_PALETTE.global.grayScale.black.b75,
    'background-color': COLOR_PALETTE.global.base.white,
    'box-shadow': COLOR_PALETTE.global.grayScale.blue2.b8,
    'border-color': COLOR_PALETTE.global.base.gray4,
    'title-color': COLOR_PALETTE.global.base.gray1,
    color: 'none'
  },
  'enphase-Pagination': {
    'background-color': COLOR_PALETTE.global.base.white,
    'hover-background-color': COLOR_PALETTE.global.base.gray5,
    'text-color': COLOR_PALETTE.global.base.gray1,
    'selected-background-color': COLOR_PALETTE.global.base.gray16
  },
  'enphase-PhoneInput': {
    'background-color': COLOR_PALETTE.global.base.white,
    error: COLOR_PALETTE.global.base.blue1,
    'country-list-hover-background-color': COLOR_PALETTE.global.base.gray18,
    'country-list-highlight-background-color': COLOR_PALETTE.global.base.gray18,
    'country-list-divider': COLOR_PALETTE.global.base.gray1,
    'box-shadow': COLOR_PALETTE.global.grayScale.black.b35
  },
  'enphase-Popover': {
    'background-color': COLOR_PALETTE.global.base.white,
    'box-shadow': COLOR_PALETTE.global.grayScale.black.b10
  },
  'enphase-Radio': {
    'text-color': COLOR_PALETTE.global.base.gray1,
    'text-color-highlight': COLOR_PALETTE.global.base.orange1,
    'text-color-disabled': COLOR_PALETTE.global.grayScale.black.b38,
    'fill-visual': COLOR_PALETTE.global.base.orange1,
    'fill-visual-background-color': COLOR_PALETTE.global.base.white,
    'fill-visual-outline': COLOR_PALETTE.global.base.gray2,
    'fill-visual-disabled': COLOR_PALETTE.global.grayScale.gray2.g30,
    'fill-visual-outline-disabled': COLOR_PALETTE.global.grayScale.gray2.g30,
    'fill-system': COLOR_PALETTE.global.base.orange1,
    'fill-system-border': COLOR_PALETTE.global.base.orange1,
    'fill-system-background-color': COLOR_PALETTE.global.base.white,
    'fill-system-outline': COLOR_PALETTE.global.base.gray2,
    'fill-system-disabled': COLOR_PALETTE.global.grayScale.gray2.g30,
    'fill-system-outline-disabled': COLOR_PALETTE.global.grayScale.gray2.g30
  },
  'enphase-RangeSlider': {
    'background-color': COLOR_PALETTE.global.base.white,
    primary: COLOR_PALETTE.global.base.orange1,
    'border-color': COLOR_PALETTE.global.base.gray4,
    'range-background-color': COLOR_PALETTE.global.base.orange11,
    'border-color2': COLOR_PALETTE.global.base.gray17,
    'label-color': COLOR_PALETTE.global.base.gray1
  },
  'enphase-Select': {
    border: COLOR_PALETTE.global.base.gray7,
    primary: COLOR_PALETTE.global.base.orange1,
    error: COLOR_PALETTE.global.base.red,
    'option-text-title': COLOR_PALETTE.global.base.gray1,
    'option-text-title-selected': COLOR_PALETTE.global.base.orange12,
    'option-text-title-hover': COLOR_PALETTE.global.base.gray18,
    divider: COLOR_PALETTE.global.base.gray1,
    'background-color': COLOR_PALETTE.global.base.white,
    'placeholder-text': COLOR_PALETTE.global.grayScale.gray1.g60
  },
  'enphase-Switch': {
    'track-color': COLOR_PALETTE.global.grayScale.gray2.g50,
    'track-color-on': COLOR_PALETTE.global.grayScale.orange1.o50,
    // "track-color-disabled" : COLOR_PALETTE.global.base.gray2,
    'thumb-color': COLOR_PALETTE.global.base.gray2,
    'thumb-shadow': COLOR_PALETTE.global.grayScale.black.b20,
    'thumb-color-on': COLOR_PALETTE.global.base.orange1,
    // "thumb-color-disabled" : "rgba(163, 163, 163, 1)",
    'text-color': COLOR_PALETTE.global.base.gray1,
    'text-color-disabled': COLOR_PALETTE.global.grayScale.black.b38
  },
  'enphase-Table': {
    primary: COLOR_PALETTE.global.base.orange1,
    'background-color': COLOR_PALETTE.global.base.white,
    'tooltip-background-color': COLOR_PALETTE.global.base.black,
    'tooltip-text-color': COLOR_PALETTE.global.base.white,
    'tooltip-border-color': COLOR_PALETTE.global.base.black,
    border: COLOR_PALETTE.global.base.gray4,
    'primary-variant': COLOR_PALETTE.global.base.blue3,
    'primary-variant-title': COLOR_PALETTE.global.base.white,
    'secondary-variant': COLOR_PALETTE.global.base.orange3,
    'box-shadow': COLOR_PALETTE.global.grayScale.gray1.g3,
    'action-button-border': COLOR_PALETTE.global.grayScale.gray1.g1,
    'text-color': COLOR_PALETTE.global.base.gray1,
    'option-label-hover-background-color': 'rgba(74, 74, 74, 0.08)',
    'header-background-color': COLOR_PALETTE.global.base.gray5,
    'selected-td': COLOR_PALETTE.global.base.orange4,
    'fixed-col-shadow': COLOR_PALETTE.global.grayScale.black.b15
  },
  'enphase-Tabs': {
    primary: COLOR_PALETTE.global.base.orange1,
    'background-color': COLOR_PALETTE.global.base.white,
    'border-color': COLOR_PALETTE.global.base.gray3,
    'fancy-background': COLOR_PALETTE.global.base.gray19,
    'fancy-text-color': COLOR_PALETTE.global.base.blue4,
    'hover-fancy-text-color': COLOR_PALETTE.global.base.blue3,
    'secondary-hover': COLOR_PALETTE.global.base.gray5,
    'icon-section-background-color': COLOR_PALETTE.global.base.orange13,
    'fancy-hover': COLOR_PALETTE.global.base.orange19
  },
  'enphase-Timepicker': {
    primary: COLOR_PALETTE.global.base.orange1,
    'time-text-color': COLOR_PALETTE.global.base.gray13,
    border: COLOR_PALETTE.global.grayScale.gray1.g1,
    'box-shadow': COLOR_PALETTE.global.grayScale.gray1.g3,
    'input-border': COLOR_PALETTE.global.base.gray7,
    'label-text-color': COLOR_PALETTE.global.base.gray6,
    'hover-background-color': COLOR_PALETTE.global.base.orange4,
    'selected-text-color': COLOR_PALETTE.global.base.white,
    'background-color': COLOR_PALETTE.global.base.white,
    'error': COLOR_PALETTE.global.base.red
  },
  'enphase-ToastMessage': {
    'box-shadow': COLOR_PALETTE.global.grayScale.gray1.g3,
    border: COLOR_PALETTE.global.grayScale.gray1.g1,
    'text-color': COLOR_PALETTE.global.base.white,
    warning: COLOR_PALETTE.global.base.orange2,
    error: COLOR_PALETTE.global.base.red,
    success: COLOR_PALETTE.global.base.green,
    info: COLOR_PALETTE.global.base.blue1,
    'icon-color': COLOR_PALETTE.global.base.white
  },
  'enphase-Tooltip': {
    'background-color': COLOR_PALETTE.global.base.black,
    error: COLOR_PALETTE.global.base.red,
    'text-color': COLOR_PALETTE.global.base.white
  },
  'enphase-TopBar': {
    'box-shadow': COLOR_PALETTE.global.grayScale.gray1.g3,
    border: COLOR_PALETTE.global.grayScale.gray1.g1,
    'background-color': COLOR_PALETTE.global.base.white,
    'dropdown-background-color': COLOR_PALETTE.global.base.white,
    'dropdown-item-hover': COLOR_PALETTE.global.grayScale.orange14.o25,
    primary: COLOR_PALETTE.global.base.orange1,
    secondary: COLOR_PALETTE.global.base.white,
    'icon-color': COLOR_PALETTE.global.base.white,
    'text-color': COLOR_PALETTE.global.base.gray1,
    'alternative-text-color': COLOR_PALETTE.global.base.white,
    'default-text-color': COLOR_PALETTE.global.base.orange1
  },
  'enphase-Typography': {
    'text-color': COLOR_PALETTE.global.base.gray1
  },
  'enphase-UploadFile': {
    primary: COLOR_PALETTE.global.base.orange1,
    border: COLOR_PALETTE.global.base.gray7,
    'text-color': COLOR_PALETTE.global.base.gray1,
    'input-text-color': COLOR_PALETTE.global.base.gray1,
    'retry-button-border': COLOR_PALETTE.global.base.gray3,
    'dropzone-background-color': COLOR_PALETTE.global.base.white,
    'dropzone-border': COLOR_PALETTE.global.base.gray3,
    error: COLOR_PALETTE.global.base.red
  } // "brand01": COLOR_PALETTE.global.base.orange1,
  // "brand02": COLOR_PALETTE.global.base.cyan,
  // "success": COLOR_PALETTE.global.base.green,
  // "information": COLOR_PALETTE.global.base.blue1,
  // "warning": COLOR_PALETTE.global.base.orange2,
  // "error": COLOR_PALETTE.global.base.red,
  // "light-orange":  COLOR_PALETTE.global.base.orange4,
  // "gray100": COLOR_PALETTE.global.base.gray1,
  // "gray50":  COLOR_PALETTE.global.base.gray2,
  // "gray30": COLOR_PALETTE.global.base.gray3,
  // "gray10": COLOR_PALETTE.global.base.gray4,
  // "gray5": COLOR_PALETTE.global.base.gray5,
  // "white": COLOR_PALETTE.global.base.white,
  // "black": COLOR_PALETTE.global.base.blue2,
  // "table-primary": COLOR_PALETTE.global.base.blue3,
  // "table-secondary": COLOR_PALETTE.global.base.orange3,
  // "disabled": COLOR_PALETTE.global.grayScale.gray2.g30,
  // "disabledText": COLOR_PALETTE.global.grayScale.black.b38,
  // "default-label": COLOR_PALETTE.global.base.gray6,
  // "default-border": COLOR_PALETTE.global.base.gray7,
  // "active-label": COLOR_PALETTE.global.base.gray6,
  // "active-text": COLOR_PALETTE.global.base.gray1,
  // "focus-border": COLOR_PALETTE.global.base.orange1,
  // "helper-text": COLOR_PALETTE.global.base.gray6,
  // "placeholder": COLOR_PALETTE.global.grayScale.gray1.g60

}; // export default {
//     "brand01": "#f37321",
//     "brand02": "#01b5de",
//     "success": "#13c333",
//     "information": "#007aff",
//     "warning": "#ff8b00",
//     "error": "#ff5959",
//     "light-orange": "#fdf1e8",
//     "gray100": "#4a4a4a",
//     "gray50": "#a3a3a3",
//     "gray30": "#c7c8ca",
//     "gray10": "#e5e5e5",
//     "gray5": "#f6f6f6",
//     "white": "#ffffff",
//     "black": "#212b36",
//     "table-primary": "#335977",
//     "table-secondary": "#FAF1E6",
//     "disabled": "#a3a3a34d",
//     "disabledText": "rgba(0, 0, 0, 0.38)",
//     "default-label": "#929292",
//     "default-border": "#b6b6b6",
//     "active-label": "#929292",
//     "active-text": "#4a4a4a",
//     "focus-border": "#f37321",
//     "helper-text": "#929292",
//     "placeholder": "rgb(74, 74, 74, 0.6)"
// }

exports.default = _default;